"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedEntityQuadTree = void 0;
const rc_js_util_1 = require("rc-js-util");
const shared_quad_tree_1 = require("./shared-quad-tree");
/**
 * @public
 * {@inheritDoc ISharedEntityQuadTree}
 */
class SharedEntityQuadTree {
    constructor(wrapper, maxDepth, maxElementsPerNode) {
        this.hitTestArg = null;
        this.entities = [];
        this.uniqueEntities = new Set();
        this.isDirty = true;
        this.sharedTree = shared_quad_tree_1.SharedQuadTree.createOneF32(wrapper, maxDepth, maxElementsPerNode);
        this.sharedObject = this.sharedTree.sharedObject;
    }
    setHitTestArg(hitTestArg) {
        this.hitTestArg = hitTestArg;
        if (this.isDirty) {
            this.regenerateIds();
        }
    }
    addEntity(entity) {
        this.uniqueEntities.add(entity);
        this.isDirty = true;
    }
    removeEntity(entity) {
        this.uniqueEntities.delete(entity);
        this.isDirty = true;
    }
    regenerateIds() {
        const uniqueEntities = this.uniqueEntities;
        const entities = this.entities = rc_js_util_1._Set.valuesToArray(uniqueEntities);
        for (let i = 0, iEnd = entities.length; i < iEnd; ++i) {
            entities[i].hitTestId = i;
        }
        this.isDirty = false;
    }
}
exports.SharedEntityQuadTree = SharedEntityQuadTree;
//# sourceMappingURL=shared-entity-quad-tree.js.map